const queryBrandAll = params => {
    return `
  
    query gearDetailQuery(
      $itemPath: String = "/sitecore/content/lynkco-global-portal/Content/Gear",
      $language: String = "${params.lang}",
    ) {
      # Datasource query
      # $datasource will always be set to the ID of the rendering's datasource item
      # (as long as the GraphQLData helper is used)
      
      gear: item(path: $itemPath, language:$language) {
        
        path
        name
        language {
          name
        }
        # Brands level
        children {
            id
            name
            template {
              name
            }
          fields (ownFields: true) {
            ...itemField
          }
        }
      }  
    }
    
    fragment itemField on ItemField {
      name
      value
      ... on ImageField{
        src
        alt
        title
        height
        width
      }
    }
  `;
  };
  
  export default queryBrandAll;
  
  